<template>
    <div>
        <el-form :inline="true" :model="batchOptForm" @submit.native.prevent>
            <el-form-item label="推广客服：">
                <el-input v-model.trim="batchOptForm.kefuName" @keyup.enter.native="getBatchOptListHandler" placeholder=""
                    clearable></el-input>
            </el-form-item>

            <el-form-item label="用户手机号：">
                <el-input v-model.trim="batchOptForm.userPhone" @keyup.enter.native="getBatchOptListHandler" placeholder=""
                    clearable></el-input>
            </el-form-item>
            <el-form-item label="推广ICCID：">
                <el-input v-model.trim="batchOptForm.oldIccid" @keyup.enter.native="getBatchOptListHandler" placeholder=""
                    clearable></el-input>
            </el-form-item>
    
            <el-form-item label="订单状态：">
                <el-select v-model="batchOptForm.state" clearable>
                    <el-option label="待发货" value="0"></el-option>
                    <el-option label="拒绝" value="5"></el-option>
                    <el-option label="已发货" value="1"></el-option>
                    <el-option label="已激活" value="2"></el-option>
                    <el-option label="已退款" value="3"></el-option>
                    <el-option label="已发奖励" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="申请时间：" class="dateRange">
                <el-date-picker v-model="batchOptForm.time" range-separator="至" type="daterange" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>

            <br/>
            <el-button type="primary" class="onlyBtn" plain @click="getBatchOptListHandler($event)">查询</el-button>

            <el-button type="primary" class="onlyBtn" plain @click="addUserHandler()">增加申请</el-button>

            <el-button type="success" class="onlyBtn" plain @click="showBatchChgStateHandler()">批量处理</el-button>
            <el-button type="success" class="onlyBtn" plain @click="importExces()">数据导出</el-button>
        </el-form>

        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
            :header-cell-style="{ background: '#f5f5f5' }">
            <el-table-column prop="oldIccid" label="推广卡号" align="center"></el-table-column>
            <el-table-column prop="oldGroupName" label="推广套餐组" align="center"></el-table-column>
            <el-table-column prop="kefuName" label="推广客服" align="center"></el-table-column>
            <el-table-column prop="userAddr" label="用户地址" align="center"></el-table-column>
            <el-table-column prop="userNmae" label="用户姓名" align="center"></el-table-column>
            <el-table-column prop="userPhone" label="用户手机号" align="center"></el-table-column>
            <el-table-column prop="stateName" label="订单状态" align="center"></el-table-column>
            <el-table-column prop="newIccid" label="发卡卡号" align="center"></el-table-column>
            <el-table-column prop="smsNo" label="快递单号" align="center"></el-table-column>
            <el-table-column prop="activeTime" label="激活时间" align="center" width="150"></el-table-column>
            <el-table-column prop="activeOrder" label="激活订单号" align="center"></el-table-column>
            <el-table-column prop="numPrice" label="发放余额" align="center"></el-table-column>

            <el-table-column align="center" label="系统备注" width="200px">
                <template v-slot="scope">
                    <el-tooltip :content="scope.row.sysRemark">
                        <p> {{ scope.row.sysRemark }}</p>
                    </el-tooltip>
                </template>
            </el-table-column>

            <el-table-column prop="createTime" label="申请时间" align="center" width="150"></el-table-column>

            <el-table-column label="操作" width="90">
                <template slot-scope="scope">
                    <el-button  type="text" size="small"
                        @click="deleteAdd(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true" title="批量导入" :visible.sync="batchOptVisible" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm" :rules="changeStateRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('userTui/export/changeSim')" :headers="setHeader()"
                        :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success='handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true" title="操作失败列表" :visible.sync="optFailVisible" width="1000px"
            :close-on-click-modal="false">
            <el-button type="primary" @click="confirmExportDialogVisible = true" style="margin-bottom:10px;"> 导
                出</el-button>
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="oldIccid" label="ICCID号"></el-table-column>
                <el-table-column prop="pkgName" label="套餐名称"></el-table-column>
                <el-table-column prop="resorceName" label="卡来源"></el-table-column>
                <el-table-column prop="oldLoseTime" label="原本过期时间"></el-table-column>
                <el-table-column prop="newLoseTime" label="导入过期时间"></el-table-column>
                <el-table-column prop="typeNickname" label="导入类型"></el-table-column>
                <el-table-column prop="disposeNickename" label="操作人"></el-table-column>
                <el-table-column prop="remark" label="错误描述"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage" :page-sizes="[10, 50, 100, 500]" :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>
        <el-dialog :append-to-body="true" title="提示" :visible.sync="confirmExportDialogVisible" width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportSimFailHandler">确 定</el-button>
            </span>
        </el-dialog>


        <el-dialog :append-to-body="true" title="发送营销短信" :visible.sync="sendFlg" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="sendInfo" :model="sendInfo" label-width="120px">

                <el-form-item label="发送类型：" prop="sendName">
                    <el-radio-group v-model="sendInfo.sendName">
                        <el-radio label="未激活">未激活卡</el-radio>
                        <el-radio label="在用卡">在用卡</el-radio>
                        <el-radio label="已激活-未续费">已激活-未续费</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="短信模板ID：" prop="msgId">
                    <el-input v-model="sendInfo.msgId" placeholder="请试下与技术沟通后固定的模板ID内容" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureSendMsg">确 定</el-button>
            </div>
        </el-dialog>














        <el-dialog :append-to-body="true" title="增加申请" :visible.sync="addFlg" width="600px" @close="cancelAdd"
            :close-on-click-modal="false">
            <el-form ref="addData" :model="addData" label-width="120px">
                <el-form-item label="推广卡号" prop="oldIccid">
                    <el-input v-model="addData.oldIccid" placeholder="请输入用户的卡号（必填）" clearable></el-input>
                </el-form-item>
                <el-form-item label="发货套餐组" prop="baseGroupName">
                    <el-input v-model="addData.baseGroupName" placeholder="请输入发货套餐组名称（必填）" clearable></el-input>
                </el-form-item>
                <el-form-item label="收货人" prop="takeNickname">
                    <el-input v-model="addData.takeNickname" placeholder="请输入收货人姓名（必填）" clearable></el-input>
                </el-form-item>
                <el-form-item label="收货手机号" prop="takePhone">
                    <el-input v-model="addData.takePhone" placeholder="请输入收货手机号（必填）" clearable></el-input>
                </el-form-item>
                <el-form-item label="收货地址" prop="userAddr">
                    <el-input v-model="addData.userAddr" placeholder="请输入用户地址（必填）" clearable></el-input>
                </el-form-item>

                <el-form-item label="推广客服" prop="kefuName">
                    <el-input v-model="addData.kefuName" placeholder="请输入推广客服姓名（必填）" clearable></el-input>
                </el-form-item>
                <el-form-item label="客服备注" prop="kefuRemark">
                    <el-input v-model="addData.kefuRemark" placeholder="请输入备注（选填）" clearable></el-input>
                </el-form-item>
           
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd">取 消</el-button>
                <el-button type="primary" @click="sureAddTui">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
import { getBatchOptList, getBatchOptFailList, batchChgState, exportSimChangeStateFail } from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data() {
        return {
            batchOptForm: {
                noDay: '',
                groupId: '',
                title: '',
                time: '',
                time1: '',
                iccid: '',
                kefuName:'',
                isPkg: '',
                isPrice: '',
                msgId: '',
                remark: '',
                vrinoStrs: '',
                userPhone: '',
                vrinoStrs: ''
            },
            batchOptForm1: {
                state: '',
                remark: '',
            },
            pkgGroup: [],
            batchOptVisible: false,
            batchOptVisible1: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            optFailVisible: false,
            currentId_fail: '',
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            confirmExportDialogVisible: false,

            changeStateRules: {
                state: [{ required: true, message: '请选择变更状态', trigger: 'blur' }],
                remark: [{ required: true, message: '请选择输入变更原因', trigger: 'blur' }],
            },

            cardStateOption: [],

            sendFlg: false,
            sendInfo: {
                msgId: '',//模板Id
                sendId: '',
                sendName: ''
            },

            addData: {
                oldIccid:'',
                userAddr: '',
                kefuName: '',
                kefuRemark: '',
                baseGroupName: '龙年推广拉新（100预存+VIP',
                takeNickname: '',
                takePhone: ''
            },
            addFlg: false,
        }
    },
    methods: {
        addUserHandler() {
            this.addFlg = true;
        },
        cancelAdd() {
            this.addFlg = false;
        },
        deleteAdd(id) {
            var data = {
                id: id
            }
            this.$confirm("删除后，将不会保留任何数据。确定要删除吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.sysRequest('userTui/delete/user', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.getBatchOptListHandler();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }

                })
            })
        },
        sureAddTui(){
            common.sysRequest('userTui/apply/sim/my', this.addData, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.addFlg=false;
                        this.getBatchOptListHandler();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }

                })

        },



        importExces() {
            common.deleteSpaceKey(this.batchOptForm);

            this.exportExcel('/mould/download/tui/sim', this.batchOptForm);
        },
        sendSmsMsg(row) {
            this.sendInfo.sendId = row.id;
            this.sendFlg = true;
        },
        sureSendMsg() {
            common.deleteSpaceKey(this.batchOptForm);
            common.sysRequest('lunxun/send/msg', this.sendInfo, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.sendFlg = false;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },



        downPdf() {
            var link = document.createElement('a');
            link.setAttribute('download', '');
            link.href = '../../../doc/发货查询.xls';
            link.click();
        },

        cancel() {
            this.sendFlg = false;
            this.batchOptVisible = false;
            this.batchOptVisible1 = false;
            this.$refs.batchOptForm.resetFields();
        },
        getBatchOptListHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.batchOptForm);
            common.sysRequest('userTui/select/user/list', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        getOptFailListHandlerUpdate(id, $event) {
            common.sysRequest('lunxun/update/active/send', this.batchOptForm, 'post').then(res => {
                if (res.data.code == 200) {
                    this.getBatchOptListHandler();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }

            })
        },
        sendMsgId() {
            common.sysRequest('lunxun/msg/active/send', this.batchOptForm, 'post').then(res => {
                if (res.data.code == 200) {
                    this.getBatchOptListHandler();
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }

            })
        },
        deleteByRemark() {
            this.$confirm("删除后，将不会保留任何数据。确定要删除吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                common.sysRequest('lunxun/delete/active/send', this.batchOptForm, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.getBatchOptListHandler();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }

                })
            })
        },


        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }

        },

        handleSuccess(res) {
            if (res.code == 200) {
                this.getBatchOptListHandler();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.upload.clearFiles();
        },

        showBatchChgStateHandler() {
            this.batchOptVisible = true;
        },
        showBatchChgStateHandler1() {
            this.batchOptVisible1 = true;
        },
        sureBatchChgStateHandler() {
            this.$refs.batchOptForm.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });
        },
        sureBatchChgStateHandler1() {
            this.$refs.batchOptForm1.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });
        },
        exportSimFailHandler() {
            let data = { "updatasId": this.currentId_fail }
            exportSimChangeStateFail(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
                this.confirmExportDialogVisible = false;
                this.optFailVisible = false;
            })
        },
        handleSizeChange(val) {
            if (this.optFailVisible) {
                this.tbpg_fail.pageSize = val;
                this.getOptFailListHandler(this.currentId_fail);
            } else {
                this.tbpg.pageSize = val;
                this.getBatchOptListHandler();
            }
        },
        handleCurrentChange(val) {
            if (this.optFailVisible) {
                this.tbpg_fail.currentPage = val;
                this.getOptFailListHandler(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val;
                this.getBatchOptListHandler();
            }
        }
    },
    created() {
        common.getPkgGroupListCom(this, 'pkgGroup');
        this.getBatchOptListHandler();
        common.sysRequest('sim/state/dict', {}, 'get').then(res => {
            if (res.data.code == 200) {
                this.cardStateOption = res.data.data;
            }
        })
    }
}
</script>
<style></style>
